// @ts-ignore
import Lottie from "react-lottie";
import "./Loading.scss";
import lottieIcon from "../../assets/loading-upload.json";
import { Text } from "../Typography";

interface Props {
  progress: number;
}

export const LoadingUpload = ({ progress }: Props) => {
  return (
    <div className="loading">
      <Lottie
        height={160}
        width={160}
        options={{
          loop: true,
          autoplay: true,
          animationData: lottieIcon,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
      />
      <Text>{progress}%</Text>
    </div>
  );
};
